<ng-template #template let-notification let-notificationData="data">
	<div class="ant-notification-notice-content" nz-row>
		<div [nzSpan]="4" nz-col>
			<i class="icon-size-27 color-red" nz nz-icon nzTheme="outline" nzType="close-circle"></i>
		</div>
		<div [nzSpan]="20" nz-col>
			<div class="ant-notification-notice-message">
				{{ "global.notifications.failed.title.failed" | translate }}
			</div>
			<div class="ant-notification-notice-description">
				{{ ("global.notifications.failed.description." + notificationData.message) | translate }}
			</div>
			<span class="ant-notification-notice-btn">
				<button (click)="notification.close()" nz-button nzSize="small" nzType="primary">
					<span>{{ "global.login.label.confirm" | translate }}</span>
				</button>
			</span>
		</div>
	</div>
</ng-template>
<form (nzClick)="redirectToLoginPage()" [formGroup]="validateLoginForm"
	  class="login-form"
	  nz-form>
	<!--<nz-input-group [nzPrefix]="prefixIcon" class="icons custom-select pl-10px pt-0 pb-0">
		<nz-select [nzDropdownStyle]="dropDownStyle" [nzSize]="'large'" class="color-grey full-width"
				   formControlName="userType" nzBorderless>
			<nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label | translate"
					   [nzValue]="option.value">
			</nz-option>
		</nz-select>
	</nz-input-group>-->
	<ng-template #prefixIcon>
		<svg fill="none" height="13" viewBox="0 0 16 13" width="16" xmlns="http://www.w3.org/2000/svg">
			<path d="M11.332 8.5H12.6654V9.83333H11.332V8.5Z" fill="#2496BE"/>
			<path d="M12.6654 5.83331H11.332V7.16665H12.6654V5.83331Z" fill="#2496BE"/>
			<path clip-rule="evenodd"
				  d="M8.66602 3.16667H15.3327V12.5H0.666016V0.5H8.66602V3.16667ZM5.33268 1.83333H7.33268V3.16667H5.33268V1.83333ZM7.33268 11.1667V9.83333H5.33268V11.1667H7.33268ZM7.33268 8.5V7.16667H5.33268V8.5H7.33268ZM7.33268 5.83333V4.5H5.33268V5.83333H7.33268ZM13.9993 11.1667V4.5H8.66602V5.83333H9.99935V7.16667H8.66602V8.5H9.99935V9.83333H8.66602V11.1667H13.9993ZM1.99935 11.1667V9.83333H3.99935V11.1667H1.99935ZM1.99935 8.5H3.99935V7.16667H1.99935V8.5ZM3.99935 5.83333V4.5H1.99935V5.83333H3.99935ZM1.99935 3.16667H3.99935V1.83333H1.99935V3.16667Z"
				  fill="#2496BE"
				  fill-rule="evenodd"/>
		</svg>
	</ng-template>
	<div class="mt-2">
		<app-input-field (ngModelChange)="checkTenderpilotEmail($event)" [formName]="'userName'" [form]="validateLoginForm"
						 [label]="'global.login.label.email' | translate"
						 [nzPrefix]="prefixIconUser"
						 [placeholder]="'global.login.placeholder.email' | translate"
						 [size]="'large'"></app-input-field>
	</div>
	<ng-template #prefixIconUser>
		<i nz-icon nzTheme="outline" nzType="user"></i>
	</ng-template>
	<div class="mt-2">
		<app-input-field [formName]="'password'" [form]="validateLoginForm"
						 [inputType]="passwordVisible ? 'text' :'password' "
						 [label]="'global.login.placeholder.password' | translate"
						 [nzPrefix]="prefixIconPassword" [nzSuffix]="suffixTemplate"
						 [placeholder]="'global.login.label.password' | translate"
						 [size]="'large'"></app-input-field>
	</div>
	<ng-template #suffixTemplate>
		<i (click)="passwordVisible = !passwordVisible" [nzType]="passwordVisible ?  'eye':'eye-invisible' "
		   nz-icon></i>
	</ng-template>
	<ng-template #prefixIconPassword>
		<i nz-icon nzTheme="outline" nzType="lock"></i>
	</ng-template>
	<div class="login-form-margin mt-1" nz-row>
		 <div nz-col [nzSpan]="12">
			<label nz-checkbox formControlName="remember">
				<span>{{ "global.login.label.remember_me" | translate }}</span>
			</label>
		</div>
		<div nz-col [nzSpan]="12">
			<a class="login-form-forgot" href="auth/forgot-password">
				{{ "global.login.label.forgot_password" | translate }}
			</a>
		</div>
	</div>
	<!--<div *ngIf="!isTenderpilotAdmin; else elseIsTenderpilotAdmin">-->
		<button (click)="submitLoginForm(template, 'buyer')" [disabled]="!validateLoginForm.valid" [nzType]="'primary'"
			class="login-form-button btn-color-default mt-0_5" nz-button
			nzBlock
			style="min-height: auto">{{ "global.login.label.sign_in_as_buyer" | translate}}</button>
		<div class="d-flex text-center vertical-align-middle center mt-0_5" id="devider">
			{{ "global.common.or" | translate}}
		</div>
		<button (click)="submitLoginForm(template, 'supplier')" [disabled]="!validateLoginForm.valid" [nzType]="'primary'"
			class="login-form-button btn-color-default mt-0_5"
			nz-button
			nzBlock>{{ "global.login.label.sign_in_as_supplier" | translate}}</button>
	<!--</div>
	<ng-template #elseIsTenderpilotAdmin>
		<button (click)="loginAsAdmin()" [disabled]="!validateLoginForm.valid" [nzType]="'primary'"
			class="login-form-button btn-color-default mt-0_5" nz-button
			nzBlock
			style="min-height: auto">{{ "global.login.label.sign_in_as_admin" | translate}}</button>
	</ng-template>-->

</form>
